module.exports = __webpack_public_path__ + "static/media/LoginPageImage.1b66fae6.jpg";